import React, { Fragment } from "react";
import { withRouter } from "react-router-dom";
import { Navbar, Nav, NavDropdown, Image } from "react-bootstrap";
import "./header.css";
const Header = (props) => {
  const scrollTo = (e, id) => {
    e.preventDefault();

    const { pathname } = props.location;

    if (pathname === "/") {
      document.getElementById(id).scrollIntoView();
    } else {
      props.history.push("/");
    }
  };
  return (
    <nav class="navbar navbar-expand-lg navbar-dark bg-dark">
      <div class="container-fluid">
        <a class="navbar-brand" href="https://fivestaruniverse.net">
          <img className="logo" src={require("../assets/img/logo.png")} />
        </a>
        <button
          class="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#main_nav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse justify-content-end" id="main_nav">
          <ul class="navbar-nav"> 
            <li class="nav-item active">
              <a class="nav-link" href="https://quote.fivestaruniverse.net/#/">
                FREE Instant Quote
              </a>
            </li>
            <li class="nav-item dropdown" id="myDropdown">
              <a
                class="nav-link dropdown-toggle"
                href="https://fivestaruniverse.net/services-2/"
                data-bs-toggle="dropdown"
              >
                Services
              </a>
              <ul class="dropdown-menu">
                <li>
                  <a
                    class="dropdown-item"
                    href="https://fivestaruniverse.net/roll-off-dumpsters/"
                  >
                    Roll-Off Dumpsters
                  </a>

                  <ul class="submenu dropdown-menu">
                    <li>
                      <a
                        class="dropdown-item"
                        href="https://fivestaruniverse.net/residential-roll-off-dumpster-rentals/"
                      >
                        Residential
                      </a>
                    </li>
                    
                    <li>
                      <a
                        class="dropdown-item"
                        href="https://fivestaruniverse.net/construction-site-roll-off-dumpsters/"
                      >
                        Construction
                      </a>
                    </li>
                    <li>
                      <a
                        class="dropdown-item"
                        href="https://fivestaruniverse.net/business-roll-off-dumpster-rentals/"
                      >
                        Business
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
            <li class="nav-item dropdown" id="myDropdown">
              <a
                class="nav-link dropdown-toggle"
                href="https://fivestaruniverse.net/dumpster-rentals-resource-center/#top"
                data-bs-toggle="dropdown"
              >
                Resources
              </a>
              <ul class="dropdown-menu">
                <li>
                  <a
                    class="dropdown-item"
                    href="https://fivestaruniverse.net/roll-off-dumpster-permits/"
                  >
                    Permits
                  </a>
                </li>
                <li>
                  <a
                    class="dropdown-item"
                    href="https://fivestaruniverse.net/accepted-and-prohibited-items/"
                  >
                    Prohibited Items
                  </a>
                </li>
                <li>
                  <a
                    class="dropdown-item"
                    href="https://fivestaruniverse.net/dumpster-delivery-tips"
                  >
                    Delivery
                  </a>
                </li>
                <li>
                  <a
                    class="dropdown-item"
                    href="https://fivestaruniverse.net/bulk-waste-disposal/"
                  >
                    Bulk Waste
                  </a>
                </li>
                <li>
                  <a
                    class="dropdown-item"
                    href="https://fivestaruniverse.net/calculating-your-dumpster-weight/"
                  >
                    Dumpster Weight
                  </a>
                </li>
                <li>
                  <a
                    class="dropdown-item"
                    href="https://fivestaruniverse.net/roll-off-dumpsters-most-frequently-asked-questions/"
                  >
                    FAQs
                  </a>
                </li>
              </ul>
            </li>

            <li class="nav-item active">
              <a
                class="nav-link"
                href="https://fivestaruniverse.net/service-areas/"
              >
                Services Area
              </a>
            </li>
            <li class="nav-item active">
              <a
                class="nav-link"
                href="https://fivestaruniverse.net/contact-us/"
              >
                Contact
              </a>
            </li>
            <li class="nav-item active">
              <a class="nav-link" href="https://fivestaruniverse.net/blogs/">
                Blog
              </a>
            </li>
            <li class="nav-item dropdown" id="myDropdown">
              <a
                class="nav-link dropdown-toggle"
                href="#"
                data-bs-toggle="dropdown"
              >
                Login
              </a>
              <ul class="dropdown-menu">
                <li>
                  <a
                    class="dropdown-item"
                    href="http://orders.fivestaruniverse.net/#/signin"
                  >
                    Affiliate Login
                  </a>
                </li>
                <li>
                  <a
                    class="dropdown-item"
                    href="http://master.fivestaruniverse.net/#/signin"
                  >
                    Master Login
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default withRouter(Header);
